import { Component, OnInit } from '@angular/core';
import { Report } from '../../../interfaces/report/report';
import { Subject } from 'rxjs';

@Component({
  selector: 'fury-marker-popup',
  templateUrl: './marker-popup.component.html',
  styleUrls: ['./marker-popup.component.scss'],
})

export class MarkerPopupComponent implements OnInit {

  public data: Report = null;
  public reports: Report[] = [];

  public sameReports: Report[] = [];

  public popupWidth$: Subject<void> = new Subject<void>();

  constructor() {
  }

  ngOnInit(): void {
    if (this.reports.length) {
      this.reports.forEach((report: Report): void => {
        if (this.data.complaint.lat === report.complaint.lat && this.data.complaint.lng === report.complaint.lng) {
          this.sameReports.push(report);
        }
      });
    }

    this.popupWidth$.next();
  }

  loadData(data: Report): void {
    this.data = data;
  }
}
